import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      top: 50%;\n      ", "\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  pointer-events: all;\n  z-index: 2;\n  height: 100%;\n  cursor: pointer;\n  top: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { getPx } from '../../../helpers/common';
import { $showMixin } from '../../../mixins/layout';
import { isDefined } from '../../../helpers/defined';
import { userSelectNoneStyle } from '../../../tokens/user-select';
import { styleArrayForBreakpoints, styleForBreakpoints } from '../../../helpers/media-style';
import { baseHighlightStyle } from '../../../tokens/highlight';
import { height } from '../../../style/height';
import { width } from '../../../style/width';
import { top } from '../../../style/top';
import { marginVertical } from '../../../style/margin-vertical';
var ItemsCarouselChevron = styled.div(_templateObject(), function (_ref) {
  var _ref$$alignX = _ref.$alignX,
      $alignX = _ref$$alignX === void 0 ? 'center' : _ref$$alignX;
  return $alignX;
}, function (_ref2) {
  var $width = _ref2.$width;
  return width($width);
}, baseHighlightStyle, userSelectNoneStyle, function (_ref3) {
  var $fullWidth = _ref3.$fullWidth,
      $width = _ref3.$width;
  return $fullWidth && css(_templateObject2(), height($width));
}, function (_ref4) {
  var $animate = _ref4.$animate;
  return styleForBreakpoints($animate, function ($animate) {
    return $animate ? "\n          transition: transform 0.2s ease-out, opacity 0.2s ease-out;\n        " : '';
  });
}, function (_ref5) {
  var $animate = _ref5.$animate,
      $slideIn = _ref5.$slideIn;
  return (
    /* prettier-ignore */
    styleForBreakpoints($animate, function ($animate) {
      return $animate ? $slideIn ? "opacity: 1;" : "opacity: 0;" : '';
    })
  );
}, function (_ref6) {
  var $animate = _ref6.$animate,
      $slideIn = _ref6.$slideIn;
  return styleForBreakpoints($animate, function ($animate) {
    return $animate && !$slideIn ? userSelectNoneStyle : '';
  });
}, function (_ref7) {
  var $fullWidth = _ref7.$fullWidth,
      value = _ref7.$topPosition;
  return $fullWidth && isDefined(value) ? top(value) : '';
}, function (_ref8) {
  var $fullWidth = _ref8.$fullWidth,
      value = _ref8.$overflowSpacingVertical,
      topPositionValue = _ref8.$topPosition;
  return $fullWidth && isDefined(value) && isDefined(topPositionValue) ? marginVertical(value) : '';
}, $showMixin);
export var ItemsCarouselRightChevron = styled(ItemsCarouselChevron)(_templateObject3(), function (_ref9) {
  var $outside = _ref9.$outside,
      $width = _ref9.$width;
  return styleArrayForBreakpoints([$outside, $width], function (_ref10) {
    var $outside = _ref10[0],
        $width = _ref10[1];
    return "right: -" + getPx($outside ? $width : 0) + ";";
  });
}, function (_ref11) {
  var $animate = _ref11.$animate,
      $slideIn = _ref11.$slideIn,
      $width = _ref11.$width,
      $fullWidth = _ref11.$fullWidth;
  return (
    /* prettier-ignore */
    styleArrayForBreakpoints([$animate, $width], function (_ref12) {
      var $animate = _ref12[0],
          $width = _ref12[1];
      return $fullWidth ? "transform: translateX(50%) translateY(-50%);" : $animate && ($slideIn ? "transform: translateX(0);" : "transform: translateX(" + getPx($width) + ");");
    })
  );
});
export var ItemsCarouselLeftChevron = styled(ItemsCarouselChevron)(_templateObject4(), function (_ref13) {
  var $outside = _ref13.$outside,
      $width = _ref13.$width;
  return styleArrayForBreakpoints([$outside, $width], function (_ref14) {
    var $outside = _ref14[0],
        $width = _ref14[1];
    return "left: -" + getPx($outside ? $width : 0) + ";";
  });
}, function (_ref15) {
  var $animate = _ref15.$animate,
      $slideIn = _ref15.$slideIn,
      $width = _ref15.$width,
      $fullWidth = _ref15.$fullWidth;
  return (
    /* prettier-ignore */
    styleArrayForBreakpoints([$animate, $width], function (_ref16) {
      var $animate = _ref16[0],
          $width = _ref16[1];
      return $fullWidth ? "transform: translateX(-50%) translateY(-50%);" : $animate && ($slideIn ? "transform: translateX(0);" : "transform: translateX(-" + getPx($width) + ");");
    })
  );
});